<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{ data.title }}</h4>
    <div mat-dialog-content class="dialog-content text-muted">
        <form [formGroup]="periodForm" class="col-12">
            <input matInput [formControlName]="'id'" hidden>
            <div class="row">
                <mat-checkbox class="col-6" formControlName="p_AdjustPeriod">
                    Adjust Period
                </mat-checkbox>

                <mat-checkbox class="col-6" formControlName="p_SetoffManual" *ngIf="periodForm.get('p_AdjustPeriod')?.value === false">
                    Set Offset Manually
                </mat-checkbox>
            </div>

            <div class="row mt-2">
                <mat-form-field class="col-6" *ngIf="periodForm.get('p_AdjustPeriod')?.value === false" appearance="outline">
                    <mat-label>Offset 1</mat-label>
                    <input matInput placeholder="Offset 1" type="number" formControlName="p_Setoff1" required>
                    <mat-error *ngIf="periodForm.get('p_Setoff1')?.hasError('required')">
                        Offset 1 are required.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="col-6" *ngIf="periodForm.get('p_AdjustPeriod')?.value === false" appearance="outline">
                    <mat-label>Offset 2</mat-label>
                    <input matInput placeholder="Offset 2" type="number" formControlName="p_Setoff2" required>
                    <mat-error *ngIf="periodForm.get('p_Setoff2')?.hasError('required')">
                        Offset 2 are required.
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="row">
                <mat-form-field class="col-6" *ngIf="periodForm.get('p_AdjustPeriod')?.value === false" appearance="outline">
                    <mat-label>Offset 3</mat-label>
                    <input matInput placeholder="Offset 3" type="number" formControlName="p_Setoff3" required>
                    <mat-error *ngIf="periodForm.get('p_Setoff3')?.hasError('required')">
                        Offset 3 are required.
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="col-6" *ngIf="periodForm.get('p_AdjustPeriod')?.value === false" appearance="outline">
                    <mat-label>Offset 4</mat-label>
                    <input matInput placeholder="Offset 4" type="number" formControlName="p_Setoff4" required>
                    <mat-error *ngIf="periodForm.get('p_Setoff4')?.hasError('required')">
                        Offset 4 are required.
                    </mat-error>
                </mat-form-field>
            </div>

        </form>
    </div>

    <div mat-dialog-actions class="dialog-actions mt-2 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{ data.cancelText }}</button>
        <button mat-button class="btn btn-success yes-button" (click)="save()" *ngIf="!isLoading; else loadingTemplate"
            cdkFocusInitial>{{ data.confirmText }}</button>
        <ng-template #loadingTemplate>
            <button mat-button class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>